/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_PublicInputs */

const en_story_public = /** @type {(inputs: Story_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const es_story_public = /** @type {(inputs: Story_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público`)
};

const fr_story_public = /** @type {(inputs: Story_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const de_story_public = /** @type {(inputs: Story_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentlich`)
};

const id_story_public = /** @type {(inputs: Story_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publik`)
};

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const ja_story_public = en_story_public;

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const zh_story_public = en_story_public;

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const ar_story_public = en_story_public;

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const it_story_public = en_story_public;

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const ru_story_public = en_story_public;

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const pt_story_public = en_story_public;

/** @type {(inputs: Story_PublicInputs) => LocalizedString} */
const ko_story_public = en_story_public;

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Story_PublicInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_public = /** @type {((inputs?: Story_PublicInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_PublicInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_public(inputs)
	if (locale === "es") return es_story_public(inputs)
	if (locale === "fr") return fr_story_public(inputs)
	if (locale === "de") return de_story_public(inputs)
	if (locale === "ja") return ja_story_public(inputs)
	if (locale === "zh") return zh_story_public(inputs)
	if (locale === "ar") return ar_story_public(inputs)
	if (locale === "id") return id_story_public(inputs)
	if (locale === "it") return it_story_public(inputs)
	if (locale === "ru") return ru_story_public(inputs)
	if (locale === "pt") return pt_story_public(inputs)
	return ko_story_public(inputs)
});